import { useEffect } from 'react';
import { isDesktopRuntime } from '@/desktop/desktopDetection';
import { BROWSER_WATCH_REPORT_INTERVAL_MS, reportBrowserWatch } from './browserWatchReporter';

/**
 * Keeps the deployment told whether a browser may watch this machine's terminals, for as long as
 * the desktop app runs (F-0225). Mounted at the application root, like `useMachineReporter`, because
 * it is a property of the machine and not of a screen.
 */
export function useBrowserWatchReporter(): void {
  useEffect(() => {
    if (!isDesktopRuntime()) return undefined;
    // A first report shortly after start, once the desktop has resumed its listener.
    const first = setTimeout(() => void reportBrowserWatch().catch(() => undefined), 5_000);
    const timer = setInterval(
      () => void reportBrowserWatch().catch(() => undefined),
      BROWSER_WATCH_REPORT_INTERVAL_MS,
    );
    return () => {
      clearTimeout(first);
      clearInterval(timer);
    };
  }, []);
}
